import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl"
import accessMaster from "./MasterControl"
import accessUsers from "./UsersControl"
import accessSettings from "./SettingsControl"
import accessProject from "./ProjectControl"
import accessFarm from "./FarmControl"
import accessMarketplace from "./MarketplaceControl"
import accessReport from "./ReportControl"
import accessGrn from "./GrnControl"
import accessUserGuide from "./UserGuideControl"
import accessCropManagement from "./CropManagementControl"
import accessConstructionManagement from "./ConstructionManagementControl"
import accessAppVersion from "./AppVersionControl"

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
    ...accessMaster,
    ...accessSettings,
    ...accessUsers,
    ...accessProject,
    ...accessFarm,
    ...accessMarketplace,
    ...accessReport,
    ...accessGrn,
    ...accessUserGuide,
    ...accessCropManagement,
    ...accessConstructionManagement,
    ...accessAppVersion,
}

export default RoutesMap;